// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footer__rights":"footer_footer__rights__U4z21","footer__social":"footer_footer__social__XFnn+"};